import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "./Button";
import { post } from "../../helpers/api_helper";

function LatestUpdate({ className = "py-10", smallContainer = false, }) {
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [alreadySubscribed, setAlreadySubscribed] = useState(false)
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    companyName: "",
    agreeToTerms: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim())
      newErrors.fullName = "Full name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Invalid email address.";
    if (!formData.companyName.trim())
      newErrors.companyName = "Company name is required.";
    if (!formData.agreeToTerms) newErrors.agreeToTerms = 'You must agree to the terms.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      await post("/NewsletterSubscriber/Subscribe", formData);
      setFormData({
        fullName: "",
        email: "",
        companyName: "",
        agreeToTerms: false,
      });
      setIsSuccess(true)
    } catch (error) {
      if(error.status === 409){
        setAlreadySubscribed(true);
      }
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-whiteSmoke/40 w-full">
      {alreadySubscribed ? 
      (
        <div className={"text-center py-4 sm:py-6 px-[10px]"}>
          <h1 className="text-darkPurple font-bold text-2xl sm:text-[40px] mb-4 sm:mb-6">
            You're already on the list! 
          </h1>
          <p className="max-w-[798px] w-full mx-auto text-base lg:text-lg text-darkGray/70 md:px-4">Looks like you've already subscribed to RegTechFlow — great minds think alike.<br />
          You're all set to receive updates, insights, and early access.</p>
        </div>
      ):
      (<div>
      {isSuccess ? (
        <div className={"text-center py-16"}>
          <h1 className="text-darkPurple font-bold text-[40px]">
            Thanks For Subscribing!
          </h1>
          <p>Check your email for confirmation message.</p>
        </div>
      ) : (
        <div className={`max-w-1200 mx-auto ${className}`}>
          <div className="px-6 max-sm:px-4 max-lg:px-6 max-lg:py-20 lg:p-8 flex flex-col items-center">
            <div className={`${smallContainer ? 'text-center lg:text-start': 'text-center'}`}>
              <p className={`font-poppins max-sm:max-w-[352px] md:max-w-[592px] md:px-[14px] text-[#1E1E1E] font-bold ${smallContainer ? 'text-2xl' : 'text-2xl md:text-3xl md:leading-[44px]'} tracking-tight`}>
                Get the latest updates by subscribing to our{" "}
                <span className="text-[#6200EE]">newsletter</span>
              </p>
            </div>
            <form
              className="mt-8 w-full lg:max-w-xl"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="mb-6">
                <label className={`font-poppins block text-sm ${smallContainer ? 'text-darkGray':'text-[#747F95]'} font-medium mb-1.5 leading-[18px]`}>
                  Full Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  className={`text-base w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 ${
                    errors.fullName
                      ? "border-red-500 focus:ring-red-500"
                      : "border-[#D0D5DD] focus:ring-[#6200EE]"
                  }`}
                />
                {errors.fullName && (
                  <p className="text-red-500 text-sm mt-1">{errors.fullName}</p>
                )}
              </div>

              <div className="mb-6">
                <label className={`font-poppins block text-sm ${smallContainer ? 'text-darkGray':'text-[#747F95]'} font-medium mb-1.5 leading-[18px]`}>
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  className={`text-base w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 ${
                    errors.email
                      ? "border-red-500 focus:ring-red-500"
                      : "border-[#D0D5DD] focus:ring-[#6200EE]"
                  }`}
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>

              <div className="mb-6">
                <label className={`font-poppins block text-sm ${smallContainer ? 'text-darkGray':'text-[#747F95]'} font-medium mb-1.5 leading-[18px]`}>
                  Company
                </label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Your company name"
                  className={`text-base w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 ${
                    errors.companyName
                      ? "border-red-500 focus:ring-red-500"
                      : "border-[#D0D5DD] focus:ring-[#6200EE]"
                  }`}
                />
                {errors.companyName && (
                  <p className="text-red-500 text-sm mt-1">{errors.companyName}</p>
                )}
              </div>
              <div className={`${smallContainer ? 'flex flex-col-reverse gap-6' : 'flex flex-col gap-6' }`}>
              <div className="mb-6">
                <label className="flex items-start space-x-2">
                  <input
                    type="checkbox"
                    name="agreeToTerms"
                    checked={formData.agreeToTerms}
                    onChange={handleChange}
                    className="h-4 w-4 text-[#6200EE] border-[#D0D5DD] rounded focus:ring-[#6200EE]"
                  />
                  <span className="text-sm text-[#747F95] font-medium">
                    By completing this form, you are also signing up to receive
                    marketing communication from us. Check out our{" "}
                    <Link
                      to="/privacy-policy"
                      className="text-[#6200EE] underline"
                    >
                      Privacy Policy
                    </Link>{" "}
                    for more info.
                  </span>
                </label>
                {errors.agreeToTerms && <p className="text-red-500 text-sm mt-1">{errors.agreeToTerms}</p>}
              </div>
              <Button type="submit" ButtonText={loading? "Subscribing....": "Subscribe"} />
              </div>
            </form>
          </div>
        </div>
      )}
      </div>)
     }
    </div>
  );
}

export default LatestUpdate;
